import React from 'react'
import ReactNipple from 'react-nipple'

const throttleAmount = 100 //max update interval (ms)

const joyOptions = {
    mode: 'dynamic',
    //catchDistance: 150,
    color: 'grey'
}

const containerStyle = {
    position: "absolute",
    height: "100%",
    width: "100%",
    top: 0
}

let lastCall = 0

export default function JoyWrapper (props) {

    const _moveListener = (event, data) => {

        // console.log('event',event,data)
        const now = new Date().getTime();
        if (now - lastCall < throttleAmount) {
            return;
        }

        lastCall = now

        props.updateJoystick(data.angle.degree*-1)
    }

    const _endListener = (event, data) => {

        //console.log('event',event,data)
        props.updateJoystick(false)
    }

    return (
        <ReactNipple
                // supports all nipplejs options
                // see https://github.com/yoannmoinet/nipplejs#options
                options={joyOptions}
                // any unknown props will be passed to the container element, e.g. 'title', 'style' etc
                style={containerStyle}
                // all events supported by nipplejs are available as callbacks
                // see https://github.com/yoannmoinet/nipplejs#start
                onMove={(event, data) => _moveListener(event, data)}
                onEnd={(event, data) => _endListener(event, data)}
            />
    )
}